import React, { useContext, useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import LoginPage from './pages/login/LoginPage';
import ErrorPage from './pages/error/ErrorPage';
import { SecurityContext } from './security/SecurityContext';
import ProtectedRoute from './security/ProtectedRoute';
import LogoutPage from './pages/logout/LogoutPage';
import PasswordResetPage from './pages/user-password-maint/PasswordResetPage';
import ProfilePage from './pages/user-profile/ProfilePage';
import { TenantContext } from './tenant/TenantContext';
import UserRegistrationPage from './pages/user-registration/UserRegistrationPage';
import UserVerificationPage from './pages/user-verification/UserVerificationPage';
import AlertsPage from './pages/alerts/AlertsPage';
import UserEstimatesPage from './pages/user-estimates/UserEstimatesPage';
import UserAgreementsPage from './pages/user-agreements/UserAgreementsPage';
import PaymentHistoryPage from './pages/payment-history/PaymentHistoryPage';
import UserFamilyPage from './pages/user-family/UserFamilyPage';
import UserSubscriptionsPage from './pages/user-subscriptions/UserSubscriptionsPage';
import UserAppointmentsPage from './pages/user-appointments/UserAppointmentsPage';
import BusinessAccounts from './pages/business-accounts/BusinessAccountsPage';
import BusinessAccountPage from './pages/business-accounts/BusinessAccountPage';
import BusinessBillsPage from './pages/business-bills/BusinessBillsPage';
import BusinessBillPage from './pages/business-bills/BusinessBillPage';
import Layout from 'uiwidgets/layouts/Layout';

import ForgotPasswordPage from 'pages/user-password-maint/ForgotPasswordPage';
import BusinessDonationCausesPage from 'pages/business-donation-causes/BusinessDonationCausesPage';
import BusinessAccountTypesPage from 'pages/business-account-types/BusinessAccountTypesPage';
import CheckoutPage from 'pages/payment-cart/CheckoutPage';
import CheckoutForm from 'pages/payment-cart/CheckoutForm';
import CheckoutResult from 'pages/payment-cart/CheckoutResult';
import UserBillsListPage from 'pages/user-bills/UserBillsListPage';
import UserBillDetailPage from 'pages/user-bills/UserBillDetailPage';
import DonationNoLoginPage from 'pages/user-donation/DonationNoLoginPage';
import PaymentHistoryDetailPage from 'pages/payment-history/PaymentHistoryDetailPage';
import RecurringPaymentListPage from 'pages/user-recurring-payments/RecurringPaymentListPage';
import RecurringPaymentPage from 'pages/user-recurring-payments/RecurringPaymentPage';
import DonationDetailPage from 'pages/user-donation/DonationDetailPage';
import BusinessMessages from 'pages/business-message/BusinessMessages';
import BusinessPromotions from 'pages/business-promotions/BusinessPromotions';
import PaymentsByDonationCause from 'pages/business-reports/PaymentsByDonationCause';
import OneClickPaymentListPage from 'pages/user-oneclick-payments/OneClickPaymentListPage';
import OneClickPaymentPage from 'pages/user-oneclick-payments/OneClickPaymentPage';
import BusinessHome from 'pages/business-home/BusinessHome';
import BusinessSponsorship from 'pages/business-donation-causes/BusinessSponsorship';
import UserSponsorships from 'pages/user-sponsorships/UserSponsorships';
import BusinessSponsors from 'pages/business-sponsors/BusinessSponsors';
import BusinessBillPayment from 'pages/business-bills/BusinessBillPayment';
import BusinessDonationBoxes from 'pages/business-donation-boxes/BusinessDonationBoxes';
import ImportAccountsPage from 'pages/business-accounts/ImportAccountsPage';
import BusinessUsersList from 'pages/business-user-admin/BusinessUsersList';
import BusinessUserEdit from 'pages/business-user-admin/BusinessUserEdit';
import BusinessResetPassword from 'pages/business-user-admin/BusinessResetPassword';
import PaymentCards from 'pages/payment-cards/PaymentCards';
import BusinessPromotion from 'pages/business-promotions/BusinessPromotion';
import UserPromotionPage from 'pages/user-promotions/UserPromotionPage';
import BusinessPromotionFulfillment from 'pages/business-promotions/BusinessPromotionFulfillment';
import BusinessBillingHome from 'pages/business-home/BusinessBillingHome';


// import { createBrowserHistory } from 'history';

// export const history = createBrowserHistory({
//     basename: process.env.PUBLIC_URL
// });

function AppRoutes() {
    const VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED'
    const secCtx = useContext(SecurityContext);
    const { businessConfig } = useContext(TenantContext);

    let regState = businessConfig['registration-state'];
    let [title, setTitle] = useState("");


    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        {!businessConfig.appFeatures.includes('DONATION_MANAGEMENT') 
                        && secCtx?.profile?.roles.includes('ROLE_BUSINESS_ADMIN') && <BusinessBillingHome/>}
                        {businessConfig.appFeatures.includes('DONATION_MANAGEMENT') 
                        && secCtx?.profile?.roles.includes('ROLE_BUSINESS_ADMIN') && <BusinessHome />}
                        {secCtx?.profile?.roles.includes('ROLE_CONSUMER') && <HomePage />}
                    </ProtectedRoute>} />

                    <Route path='home' element={
                        (secCtx?.authState && secCtx?.profile?.roles.includes('ROLE_BUSINESS_ADMIN') && regState === VERIFICATION_REQUIRED) ?

                            (
                                <Navigate replace to="/verifyemail" />
                            )
                            :
                            (
                                <ProtectedRoute isAllowed={secCtx.authState}>
                                    {!businessConfig.appFeatures.includes('DONATION_MANAGEMENT') 
                                    && secCtx?.profile?.roles.includes('ROLE_BUSINESS_ADMIN') && <BusinessBillingHome/>}
                                    {businessConfig.appFeatures.includes('DONATION_MANAGEMENT') 
                                    && secCtx?.profile?.roles.includes('ROLE_BUSINESS_ADMIN') && <BusinessHome />}
                                    {secCtx?.profile?.roles.includes('ROLE_CONSUMER') && <HomePage />}
                                </ProtectedRoute>
                            )
                    }
                    />
                    <Route path="/wallet" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                            <PaymentCards />
                        </ProtectedRoute>
                    } />

                    <Route path='/alerts' element={<ProtectedRoute isAllowed={secCtx.authState}>
                        <AlertsPage />
                    </ProtectedRoute>} />

                    <Route path="/recurring-payments" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <RecurringPaymentListPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/add-recurring-payments" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <RecurringPaymentPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/edit-recurring-payments/:recpmtid" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <RecurringPaymentPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/oneclick-payments" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <OneClickPaymentListPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/edit-oneclick-payments/:oneclickpmtid" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <OneClickPaymentPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/add-oneclick-payments" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <OneClickPaymentPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/user-sponsorships" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <UserSponsorships />
                        </ProtectedRoute>
                    } />

                    <Route element={<CheckoutPage />}>
                        <Route path="/checkout-result" element={<CheckoutResult />} />
                        <Route path="/checkout-form" element={<CheckoutForm/>}></Route>
                    </Route>

                    <Route path="/user-bills/:accountId" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserBillsListPage /></ProtectedRoute>} />
                    <Route path="/user-bill-detail/:billId?" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserBillDetailPage /></ProtectedRoute>} />


                    <Route path='/user-donation/:causeCode' element={<DonationNoLoginPage />} />
                    <Route path='/user-donation' element={<DonationNoLoginPage />} />
                    <Route path="/user-donation-detail/:donationId" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <DonationDetailPage /></ProtectedRoute>} />

                    <Route path='/user-estimates' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserEstimatesPage />
                    </ProtectedRoute>} />

                    <Route path='/user-agreements' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserAgreementsPage />
                    </ProtectedRoute>} />

                    <Route path='/payment-history' element={<ProtectedRoute isAllowed={secCtx.authState && ["ROLE_CONSUMER", "ROLE_BUSINESS_ADMIN"].some(role => secCtx.profile.roles.includes(role))}>
                        <PaymentHistoryPage />
                    </ProtectedRoute>} />
                    <Route path='/payment-history/:paymentId' element={<ProtectedRoute isAllowed={secCtx.authState && ["ROLE_CONSUMER", "ROLE_BUSINESS_ADMIN"].some(role => secCtx.profile.roles.includes(role))}>
                        <PaymentHistoryDetailPage />
                    </ProtectedRoute>} />

                    <Route path='/user-family' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserFamilyPage />
                    </ProtectedRoute>} />

                    <Route path='/user-subscriptions' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserSubscriptionsPage />
                    </ProtectedRoute>} />

                    <Route path='/user-appointments' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserAppointmentsPage />
                    </ProtectedRoute>} />

                    <Route path='/user-promotions/:promotionId' element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")}>
                        <UserPromotionPage/>
                    </ProtectedRoute>} />

                    <Route path='/resetpassword' element={<ProtectedRoute isAllowed={secCtx.authState}>
                        <PasswordResetPage /></ProtectedRoute>} />

                    <Route path='/forgotpassword' element={<ForgotPasswordPage />} />

                    <Route path="/login"
                        element={
                            (secCtx?.profile?.passwordExpired) ?
                                (
                                    <Navigate replace to="/resetpassword" />
                                )
                                :
                                (
                                    <LoginPage />
                                )
                        }
                    />


                    <Route path="/logout" element={<LogoutPage />} />

                    <Route path='/profile' element={<ProtectedRoute isAllowed={secCtx.authState}>
                        <ProfilePage />
                    </ProtectedRoute>} />

                    <Route path="/business-paymentcards" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <PaymentCards />
                        </ProtectedRoute>
                    } />

                    <Route path="/business-sponsors" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessSponsors />
                        </ProtectedRoute>
                    } />

                    <Route path="/business-dashboard" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessHome />
                        </ProtectedRoute>
                    } />

                    <Route path="/businesspmtreportbydoncause" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <PaymentsByDonationCause />
                    </ProtectedRoute>} />

                    <Route path="/businessmessages" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessMessages />
                    </ProtectedRoute>} />

                    <Route path="/businesspromotions" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessPromotions />
                    </ProtectedRoute>} />
                    <Route path="/businesspromotion/:promotionId" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessPromotion />
                    </ProtectedRoute>} />
                    <Route path="/businesspromofulfilment/:promotionId" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessPromotionFulfillment />
                    </ProtectedRoute>} />

                    <Route path="/businessdonationcauses" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessDonationCausesPage />
                    </ProtectedRoute>} />

                    <Route path="/businesssponsorships" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessSponsorship />
                    </ProtectedRoute>} />

                    <Route path="/businessaccounttypes" element={<ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                        <BusinessAccountTypesPage />
                    </ProtectedRoute>} />

                    <Route path="/businessdonationboxes" element={<ProtectedRoute isAllowed={secCtx.authState && 
                        (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") || secCtx.profile.roles.includes("ROLE_DONATION_BOX"))   }>
                        <BusinessDonationBoxes />
                    </ProtectedRoute>} />

                    <Route path="/businessaccounts" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessAccounts />
                        </ProtectedRoute>}>
                    </Route>

                    <Route path="/businessaccount" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessAccountPage />
                        </ProtectedRoute>}>
                    </Route>

                    <Route exact path="/businessaccounts/import" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <ImportAccountsPage />
                        </ProtectedRoute>}>
                    </Route>

                    <Route exact path="/businessaccounts/:accountId" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessAccountPage />
                        </ProtectedRoute>}>
                    </Route>

                    

                    <Route path="/businessbills" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessBillsPage />
                        </ProtectedRoute>}>
                    </Route>

                    <Route path="/accountbusinessbill/:accountId" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessBillPage />
                        </ProtectedRoute>}>
                    </Route>

                    <Route exact path="/businessbills/:billId" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessBillPage />
                        </ProtectedRoute>}>
                    </Route>

                    <Route exact path="/businessusers" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessUsersList/>
                        </ProtectedRoute>}>
                    </Route>
                    <Route exact path="/businessusers/:userId" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessUserEdit />
                        </ProtectedRoute>}>
                    </Route>
                    <Route exact path="/business-resetpassword" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <BusinessResetPassword/>
                        </ProtectedRoute>}>
                    </Route>

                    <Route path="/admin-add-recurring-payments" element={
                        <ProtectedRoute isAllowed={secCtx.authState}>
                            <RecurringPaymentPage />
                        </ProtectedRoute>
                    } />

                    <Route path="/admin-edit-recurring-payments/:recpmtid" element={
                        <ProtectedRoute isAllowed={secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")}>
                            <RecurringPaymentPage />
                        </ProtectedRoute>
                    } />


                    <Route path="/register-user" element={<UserRegistrationPage />} />
                    <Route exact path='/verify-user/:userId' element={<UserVerificationPage />} />
                    <Route path="*" element={<ErrorPage />} />



                </Route>


            </Routes>
        </Router>
    )
}

export default AppRoutes